import { API, ENDPOINTS } from '@/app/services/api-url';

export const AccountApi = {
  getAccounts() {
    return API.get(ENDPOINTS.GET_ACCOUNTS);
  },
  getAccount(accountId) {
    return API.get(`${ENDPOINTS.GET_ACCOUNTS}/${accountId}`);
  },
  getAccountUser(accountId) {
    return API.get(`${ENDPOINTS.GET_ACCOUNTS}/${accountId}/accountuser`);
  },
  getUserAccount() {
    return API.get(`${ENDPOINTS.GET_ACCOUNTUSER}`);
  },
  getAppPermissionsByAccountId(accountId) {
    return API.get(`${ENDPOINTS.GET_APP_PERMISSIONS}?accountID=${accountId}`);
  },
  getBorgApiKey(activeAccountUUID) {
    return API.get(`${ENDPOINTS.GET_INTEGRATION_API_KEY}?accountID=${activeAccountUUID}`);
  },
  createAccount(data) {
    return API.post(`${ENDPOINTS.POST_ACCOUNT}`, data);
  },
  updateAccount(activeAccount) {
    return API.post(`${ENDPOINTS.POST_ACCOUNT}/${activeAccount.uuid}`, activeAccount);
  },
};

export { AccountApi as default };
